module.exports = __webpack_public_path__ + "static/media/notif.b8c781fd.svg";